// Разбирает имя поля в путь: "a" → ["a"], "a[]" → ["a", ""],
// "a[b][]" → ["a", "b", ""]. Пустой сегмент означает «добавить в конец массива».
function parsePath(name) {
    const match = name.match(/^([^[\]]*)((?:\[[^[\]]*\])*)$/);

    // Имя не в скобочной нотации (например, с вложенными скобками) — берём целиком
    if (!match) {
        return [name];
    }

    const segments = [match[1]];

    for (const bracket of match[2].matchAll(/\[([^[\]]*)\]/g)) {
        segments.push(bracket[1]);
    }

    return segments;
}

const isIndex = segment => /^\d+$/.test(segment);

function setDeep(root, segments, value) {
    let node = root;

    for (let i = 0; i < segments.length; i++) {
        const segment = segments[i];

        if (i === segments.length - 1) {
            if (segment === "") {
                node.push(value);
            } else {
                node[segment] = value;
            }
            return;
        }

        const next = segments[i + 1];
        const container = next === "" || isIndex(next) ? [] : {};

        if (segment === "") {
            // "[]" в середине пути — каждое значение уходит в новый элемент
            node.push(container);
            node = container;
        } else {
            if (typeof node[segment] !== "object" || node[segment] === null) {
                node[segment] = container;
            }
            node = node[segment];
        }
    }
}

/**
 * Сериализует данные формы в объект.
 * Имена полей понимаются как в PHP: "a[b]", "a[]", "a[b][]".
 * @param {HTMLFormElement} formElement - Элемент формы для сериализации.
 * @returns {Object} - Объект с данными формы.
 */
export default function serializeForm(formElement) {
    const formDataObject = {};
    const formData = new FormData(formElement);

    // Одно имя может встречаться много раз (группы чекбоксов), поэтому
    // обходим уникальные имена и забираем все значения разом
    for (const name of new Set(formData.keys())) {
        const segments = parsePath(name);
        const values = formData.getAll(name);

        if (segments.includes("")) {
            for (const value of values) {
                setDeep(formDataObject, segments, value);
            }
        } else {
            // Как в PHP: при дублях имени побеждает последнее значение
            setDeep(formDataObject, segments, values[values.length - 1]);
        }
    }

    return formDataObject;
}
